import Vue from "vue";
import { toEnglish } from "@/mixins/toEnglish";

Vue.mixin(toEnglish);
